import { createSlice } from '@reduxjs/toolkit';

// Define the initial state using that type
const initialState: IDimmsState = {
    data: null,
    pageSize: 0,
    pageNumber: 0,
    totalCount: 0,
    showLoading: {
        sourceAction: '',
        state: false,
    },
    isLoading: false,
    isSuccess: false,
    details: null,
};

export const dimmsSlice = createSlice({
    name: 'dimms',
    // `createSlice` will infer the state type from the `initialState` argument
    initialState,
    reducers: {
        setLoading: (state, action) => {
            const { isLoading, isSuccess } = action.payload;
            state.showLoading = {
                sourceAction: action.payload.sourceAction,
                state: true,
            };
            state.isLoading = isLoading ? isLoading : false;
            state.isSuccess = isSuccess ? isSuccess : false;
        },
        resetLoading: (state, action) => {
            const { isLoading, isSuccess } = action.payload;
            state.showLoading = {
                sourceAction: '',
                state: false,
            };
            state.isLoading = isLoading ? isLoading : false;
            state.isSuccess = isSuccess ? isSuccess : false;
        },
        replaceDimms: (state, action) => {
            const { data, pageSize, pageNumber, totalCount } = action.payload;
            state.data = data;
            state.pageSize = pageSize;
            state.pageNumber = pageNumber;
            state.totalCount = totalCount;
        },
        setDimmsDetails: (state, action) => {
            state.details = action.payload.data;
        }
    },
});

export const dimmsActions = dimmsSlice.actions;

export default dimmsSlice.reducer;
